import ProBlogPostList from './ProBlogPostList';
import type { ProBlogPostListProps } from './ProBlogPostList';

export type { ProBlogPostListProps };
export default ProBlogPostList;
